import React from "react";
import {
  useTable,
  useSortBy,
  useFilters,
  usePagination,
  useExpanded,
  useColumnOrder,
  useFlexLayout,
  useGlobalFilter
} from "react-table";
import DropDownListFilter from "./DropDownListFilter";
import SelectInputFilter from "./SelectInputFilter";
import TextBoxFilter from "./TextBoxFilter";
import Button from "../../../components/Button";
import ButtonList from "../../../components/ButtonList";
import ColumnSelectorCheckbox from "./ColumnSelectorCheckbox";
import LinkButton from "../../../components/LinkButton";
import Tooltip from "../../../components/Tooltip";
import Modal from "../../../components/ModalPopup";
import Loader from "../../../components/Loader";
import { useSticky } from "react-table-sticky";
import { FHIRRecordDetails } from "../../../components/FHIRRecordDetails";
import NewPagination from "../../../components/NewPagination";
import Search from "../../SearchRecords/Search";
import SuperScriptAdder from "./SuperScriptAdder";
import TogglingButton from "../../../components/TogglingButton";
import { useAuthState } from "../../../components/AuthProvider";
import Container from "../../../components/Container";
import { useHistory, Link } from "react-router-dom";
import FHIRDetails from "../../../components/FHIRDetails";
import { useMessageToast } from "../../../components/MessageProvider";
import fetchConfig from "../../../utils/fetchConfig";
import handleResponse from "../../../utils/handleFetchResponse";

import styles from "./DataTable.module.scss";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { map } from "lodash";
const defaultPropGetter = () => ({});

const DataTable = ({
  downloadCsvName = "",
  columns,
  data,
  csvColumns = null,
  hasFlexLayout = false,
  hasFiltering = false,
  hasPagination = false,
  hasSearchBar = false,
  hasSorting = false,
  hasDownloadCsv = false,
  showColumnSelector = false,
  hasSubRows = false,
  hasHover = true,
  tooltipContent = "",
  tooltipPlacement = "bottom",
  isStripped = true,
  isNewQuarantine = false,
  quarantineRecordId,
  quarantineSourceId,
  entityId,
  sourceId,
  hiddenColumns = [],
  columnOrder,
  getHeaderProps = defaultPropGetter,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
  maxWidth = null,
  expandableData,
  recordHistoryData = [],
  closeClick,
  paginationPageSize = 10,
  criteria,
  onChange,
  onSearch,
  options,
  showScores = false,
  showRelatedIdsScores = false,
  isReviewQueueTable = false,
  hasGlobalFiltering = false,
  changeRecorodOverrideStatus,
  updateAuxData,
  isRelatedIdentitesSearch = false,
  goldenId,
  mergeIdentitySpecEnableDisableMap,
  handleMergeIdentitySpec,
  primarySpecId,
  handleScoreString,
  FHIRRecordList = [],
  quarantineRecordDetails,
  nameToTypeMap,
  ...rest
}) => {
  const toast = useMessageToast();
  const [tableExpanded, setTableExpanded] = React.useState(false);
  const [expandRecordDetails, setExpandRecordDetails] = React.useState(false);
  const [
    unquarantineRecordDialog,
    setUnquarantineRecordDialog
  ] = React.useState(false);
  const [rowPopOverVisible, setRowPopoverVisible] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = React.useState();
  const [expandedRow, setExpandedRow] = React.useState();
  const [
    showRelatedIdentityScore,
    setShowRelatedIdentityScore
  ] = React.useState(false);

  const [
    unquarantineLoadingState,
    setUnquarantineLoadingState
  ] = React.useState(false);

  const history = useHistory();
  const { user } = useAuthState();
  const { selectedClient } = user.preferences;

  const {
    selectedClient: { id: clientIdNumber }
  } = user.preferences;

  // WARN: the way of escaping commas and newlines is not universal because there isn't a single CSV spec
  const generateCsvLink = () => {
    let strCsv = "";
    let accessors = [];
    if (csvColumns === null) {
      columns.forEach(row => {
        strCsv += '"' + row.Header.replace(/"/g, '"""') + '",';
        accessors.push(row.accessor);
      });
    } else {
      csvColumns.forEach(row => {
        strCsv += '"' + row.Header.replace(/"/g, '""') + '",';
        accessors.push(row.accessor);
      });
    }
    data.forEach(row => {
      strCsv += "\n";
      accessors.forEach(accessor => {
        const val = String(row[accessor]);
        strCsv += '"' + val.replace(/"/g, '""') + '",';
      });
    });

    const url = URL.createObjectURL(new Blob([strCsv], { type: "text/csv" }));

    if (downloadCsvName) {
      /* Create not visble a href which allows us to name the file name */
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = downloadCsvName;
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } else {
      window.location.href = url;
    }
  };

  const paginationUtil = () => {
    return (
      <NewPagination
        resultsCount={data.length}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        previousPage={previousPage}
        nextPage={nextPage}
      />
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    allColumns,
    setColumnOrder,
    state,
    setGlobalFilter
  } = useTable(
    {
      columns,
      data,
      initialState: { hiddenColumns, pageSize: paginationPageSize }
    },
    useGlobalFilter,
    hasFiltering && useFilters,
    hasSorting && useSortBy,
    hasPagination && usePagination,
    hasSubRows && useExpanded,
    hasFlexLayout && useFlexLayout,
    useSticky,
    useColumnOrder
  );

  const { globalFilter } = state;
  const { pageIndex } = state;

  React.useEffect(() => {
    setColumnOrder(columnOrder);
  }, [columnOrder]);

  React.useEffect(() => {
    setShowRelatedIdentityScore(showRelatedIdsScores);
  }, [showRelatedIdsScores]);

  const constructGoldenIdNumberMap = rows => {
    const res = {};
    rows.forEach(row => {
      if (
        row.original.hasOwnProperty("scoreId") &&
        row.original.recordNumberInGoldenId !== null
      ) {
        // focusidentity
        if (res["@" + goldenId]) {
          res["@" + goldenId] = [...res["@" + goldenId], row];
        } else {
          res["@" + goldenId] = [row];
        }
      } else if (
        row.original.hasOwnProperty("scoreId") &&
        row.original.recordNumberInGoldenId === null
      ) {
        // relatedIdentity
        if (res["@" + row.original.scoreId]) {
          res["@" + row.original.scoreId] = [
            ...res["@" + row.original.scoreId],
            row
          ];
        } else {
          res["@" + row.original.scoreId] = [row];
        }
      } else {
        // focus and relatedIdentity
        if (res["@" + row.original.goldenId]) {
          res["@" + row.original.goldenId] = [
            ...res["@" + row.original.goldenId],
            row
          ];
        } else {
          res["@" + row.original.goldenId] = [row];
        }
      }
    });
    return res;
  };

  const openExpandModal = row => {
    setExpandedRow(row);
    setExpandRecordDetails(true);
  };
  const openUnquarantineModal = row => {
    setUnquarantineRecordDialog(true);
  };
  const expandRecordDetailsUtil = () => {
    if (expandedRow == null) {
      return;
    }
    return (
      <Modal
        open={expandRecordDetails}
        onClose={() => setExpandRecordDetails(false)}
      >
        <FHIRDetails patient={FHIRRecordList[parseInt(expandedRow.id, 10)]} />
        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button
              primary
              onClick={() => openUnquarantineModal(expandedRow)}
              isInvisible={!expandedRow.original.undoQuarantine}
              disabled={unquarantineLoadingState}
            >
              Undo Quarantine
            </Button>
            <Button primary onClick={() => setExpandRecordDetails(false)}>
              Close
            </Button>
            <Loader loading={unquarantineLoadingState}></Loader>
          </ButtonList>
        </div>
      </Modal>
    );
  };
  const unquarantineRecordUtil = () => {
    return (
      <Modal
        open={unquarantineRecordDialog}
        onClose={() => setUnquarantineRecordDialog(false)}
      >
        <div>Are you sure you want to unquarantine this record?</div>
        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button primary onClick={() => setUnquarantineRecordDialog(false)}>
              Cancel
            </Button>
            <Button
              primary
              onClick={() => handleUnquarantineRequest(expandedRow.id)}
            >
              Confirm
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  const handleUnquarantineRequest = id => {
    setUnquarantineRecordDialog(false);
    setUnquarantineLoadingState(true);
    const inputBody = FHIRRecordList[parseInt(id, 10)];
    if (inputBody.meta.lastUpdated) {
      delete inputBody.meta.lastUpdated;
    }
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patientsource/unquarantine`;
    const mockUrl = `/unquarantineResponse.json`;
    const config = {
      method: "PUT",
      body: JSON.stringify(inputBody),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        userId: user.username,
        "Content-Type": "application/json",
        sourceId: sourceId,
        sourceEntityId: entityId
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        setUnquarantineLoadingState(false);
        setExpandRecordDetails(false);
        const goldenIdNew = response.data.id;
        history.push({
          pathname: `/search-identities-new/${selectedClient.oid}/view/${goldenIdNew}/`,
          state: {
            preLoadedSearchCriteria: [
              {
                key: "golden_id",
                label: "HCM ID/EID",
                value: goldenIdNew
              }
            ]
          }
        });
        toast.success(`Unquarantine Completed`);
        window.location.reload();
      })
      .catch(error => {
        console.log("unquarantine error: ", error);
        toast.error("Error occured while unquarantining record");
        setUnquarantineLoadingState(false);
      });
  };

  const renderTable = rows => {
    let rowsLength = rows.length / 2;
    return rows.map((row, i) => {
      prepareRow(row);
      return (
        <React.Fragment key={i}>
          {(showScores || showRelatedIdentityScore) &&
          row.original.hasOwnProperty("scoreId") &&
          row.original.recordNumberInGoldenId !== rowsLength ? (
            <tr
              className={`${styles.scoreRow} ${
                showRelatedIdentityScore ? styles.relatedIdScoreRow : ""
              }`}
              {...row.getRowProps([getRowProps(row)])}
            >
              {row.cells.map(cell => {
                if (cell.column.id === "actions") {
                  return (
                    <td
                      {...cell.getCellProps([
                        { style: cell.column.style },
                        getCellProps(cell)
                      ])}
                    >
                      <LinkButton
                        onClick={() => {
                          handleScoreString(row.original.scoreString);
                        }}
                      >
                        {row.original.actions.toFixed(2)}
                      </LinkButton>
                    </td>
                  );
                }
                if (cell.column.id === "moreoptions") {
                  return (
                    <td
                      {...cell.getCellProps([
                        { style: cell.column.style },
                        getCellProps(cell)
                      ])}
                    ></td>
                  );
                }
                return (
                  <td
                    {...cell.getCellProps([
                      { style: cell.column.style },
                      getCellProps(cell)
                    ])}
                    className={`${
                      row.original[cell.column.id] < 0
                        ? styles.negativeScoreCell
                        : cell.column.id ===
                          row.original.maxScoreElement.element
                        ? styles.positiveScoreCell
                        : styles.scoreRow
                    }`}
                  >
                    {cell.render("Cell")}
                    <SuperScriptAdder
                      rowValue={row.original}
                      headerId={cell.column.id}
                    />
                  </td>
                );
              })}
            </tr>
          ) : null}

          {!row.original.hasOwnProperty("scoreId") ? (
            <tr
              {...row.getRowProps([getRowProps(row)])}
              className={`${hasHover ? styles.hasHover : ""} ${
                isStripped ? styles.stripped : ""
              } ${
                row.original.quarantineStatus
                  ? styles.quarantineRow
                  : row.original.source === "TMX_LN"
                  ? styles.tmxLnRow
                  : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={
                FHIRRecordList.length > 0 ? () => openExpandModal(row) : null
              }
            >
              {row.cells.map(cell => {
                if (cell.column.id === "actions") {
                  return (
                    <td
                      className={`${
                        row.original.isExpanded ? styles.highlighted : ""
                      }  ${
                        row.original.recordNumberInGoldenId === 1 &&
                        row.original.goldenIdNumber !== 2 &&
                        row.original.table === "secondary" &&
                        !showRelatedIdentityScore
                          ? styles.identitySeparator
                          : ""
                      }`}
                      {...cell.getCellProps([
                        { style: cell.column.style },
                        getCellProps(cell)
                      ])}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                }
                return (
                  <td
                    {...cell.getCellProps([
                      { style: cell.column.style },
                      getCellProps(cell)
                    ])}
                    className={`${
                      row.original.recordNumberInGoldenId === 1 &&
                      row.original.goldenIdNumber !== 2 &&
                      row.original.table === "secondary" &&
                      !showRelatedIdentityScore
                        ? styles.identitySeparator
                        : ""
                    }`}
                  >
                    {cell.render("Cell")}
                    <SuperScriptAdder
                      headerName={cell.column.Header}
                      rowValue={row.original}
                    />
                  </td>
                );
              })}
            </tr>
          ) : null}

          {row.original.isExpanded ? (
            <div
              style={{
                position: "sticky",
                "z-index": "999",
                left: "10px",
                width: "90rem"
              }}
            >
              <tr
                className={styles.expandedRow}
                onClick={
                  FHIRRecordList.length > 0 ? () => openExpandModal(row) : null
                }
              >
                <Container className={styles.expandedSection}>
                  <FHIRRecordDetails
                    className={styles.fhirDetails}
                    patientRecordDetails={expandableData.find(
                      record =>
                        `${record.id}+${record.meta.source}` === row.original.id
                    )}
                    quarantineRecordDetails={quarantineRecordDetails}
                    membershipHistoryDetails={data.find(
                      ar => ar.recordId === row.original.recordId
                    )}
                    recordHistory={recordHistoryData.get(row.original.recordId)}
                    onCloseClick={closeClick}
                    oncRecordOverrideIconClick={(
                      detailsMap,
                      patientRecordDetails
                    ) =>
                      changeRecorodOverrideStatus(
                        detailsMap,
                        patientRecordDetails
                      )
                    }
                    defaultRecordHistoryTab={
                      `${quarantineRecordId}+${quarantineSourceId}` ===
                      row.original.id
                    }
                    isNewQuarantine={isNewQuarantine}
                    recordId={row.original.id}
                    nameToTypeMap={nameToTypeMap}
                  />
                </Container>
              </tr>
            </div>
          ) : null}
        </React.Fragment>
        // </div>
      );
    });
  };

  return (
    <div className={styles.base}>
      {hasGlobalFiltering && (
        <div className={styles.searchContainer}>
          <div className={styles.searchBox}>
            <span className={styles.searchText}>Search</span>
            <input
              type="text"
              className={styles.searchInput}
              value={globalFilter || ""}
              onChange={e => setGlobalFilter(e.target.value)}
              placeholder="Filter table data"
            />
          </div>
        </div>
      )}
      <div className={styles.table}>
        {hasSearchBar ? (
          <div className={styles.searchRecordTable}>
            <span className={styles.searchBar}>
              {/* {console.log("search criteria "+ criteria)} */}
              <Search
                criteria={criteria}
                onChange={onChange}
                onSearch={onSearch}
                options={options}
                searchLabel={"Search Criteria"}
                searchRelatedIdentities={true}
              />
              {/*  <i className={styles.searchInstruction}>
                    Supported Search Criteria: Patient Identifier, Given Name,
                    Family Name, Date of Birth, Root OID and Extension
                  </i>*/}
            </span>

            {!isRelatedIdentitesSearch && (
              <span className={styles.scoreToggleButtonBar}>
                <span className={styles.scoreToggleButton}>
                  <TogglingButton
                    value={showRelatedIdentityScore}
                    setState={setShowRelatedIdentityScore}
                  />
                </span>
                <span className={styles.showScoresText}>
                  {showRelatedIdentityScore ? "Hide " : "Show "}Related Identity
                  Scores
                </span>
              </span>
            )}
          </div>
        ) : (
          hasPagination && paginationUtil()
        )}
        {showColumnSelector ? (
          <div className={styles.toggleButton}>
            <LinkButton
              icon={tableExpanded ? "contract" : "expand"}
              style={{ outline: "#fff", marginLeft: "auto" }}
              onClick={() => setTableExpanded(!tableExpanded)}
            />
          </div>
        ) : null}
        <div
          className={`${styles.wrapper} ${
            tableExpanded ? styles.wrapperXl : ""
          } ${rest.className ? rest.className : ""}`}
          style={{ maxWidth: maxWidth }}
        >
          <table {...getTableProps()} className={styles.sticky}>
            <thead className={styles.thead}>
              {headerGroups.map(headerGroup => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className={styles.tr}
                >
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps([
                        hasSorting ? column.getSortByToggleProps() : "",
                        {
                          style: column.style
                        },
                        getHeaderProps(column)
                      ])}
                      className={styles.th}
                    >
                      {column.render("Header")}
                      <span className={styles.headerIcon}>
                        {typeof column.Header === "function" &&
                        column.Header() &&
                        column.Header().props.children.length > 1 &&
                        column.Header().props.children[1] &&
                        tooltipContent ? (
                          <Tooltip placement={tooltipPlacement}>
                            {tooltipContent}
                          </Tooltip>
                        ) : null}
                        {column.canSort ? (
                          column.isSorted ? (
                            column.isSortedDesc ? (
                              <span className={styles.iconCaretUp} />
                            ) : (
                              <span className={styles.iconCaretDown} />
                            )
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4.55 7.15l3.4-4.6 3.45 4.6z"></path>
                              <path d="M11.4 8.65l-3.45 4.65-3.4-4.65z"></path>
                            </svg>
                          )
                        ) : (
                          " "
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className={styles.body}>
              {data.length === 0 ? (
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={columns.length}>
                    No data to show
                  </td>
                </tr>
              ) : (
                Object.entries(
                  hasPagination
                    ? constructGoldenIdNumberMap(page)
                    : constructGoldenIdNumberMap(rows)
                ).map((idnumber, index) => {
                  const aggregateId = idnumber[0].substring(1);
                  const isAccordianRequired =
                    (idnumber[1] &&
                      idnumber[1].length > 0 &&
                      idnumber[1][0].original.table === "primary") ||
                    idnumber[1][0].original.table === "secondary" ||
                    idnumber[1][0].original.hasOwnProperty("scoreId");
                  return (
                    <>
                      {isAccordianRequired ? (
                        <Accordion allowZeroExpanded preExpanded={[0]}>
                          <AccordionItem uuid={index}>
                            <AccordionItemHeading>
                              <AccordionItemButton style={{ width: "auto" }}>
                                {
                                  <div
                                    style={{
                                      "z-index": "999",
                                      position: "sticky",
                                      left: "20px",
                                      width: "24%",
                                      display: "inline-block"
                                    }}
                                  >
                                    {goldenId !== aggregateId && (
                                      <Link
                                        onClick={() => {
                                          history.push({
                                            pathname: `/search-identities-new/${selectedClient.oid}/view/${aggregateId}/`,
                                            state: {
                                              preLoadedSearchCriteria: [
                                                {
                                                  key: "golden_id",
                                                  label: "HCM ID/EID",
                                                  value: aggregateId
                                                }
                                              ]
                                            }
                                          });
                                          window.location.reload();
                                        }}
                                        style={{ textDecoration: "none" }}
                                      >
                                        <LinkButton
                                          icon="arrow_wtail_bold_up"
                                          style={{ float: "left" }}
                                          title="Make Focus Identity"
                                        />
                                      </Link>
                                    )}

                                    {aggregateId}

                                    {primarySpecId &&
                                      goldenId !== aggregateId &&
                                      mergeIdentitySpecEnableDisableMap &&
                                      mergeIdentitySpecEnableDisableMap.has(
                                        aggregateId
                                      ) &&
                                      mergeIdentitySpecEnableDisableMap.get(
                                        aggregateId
                                      ).size === 0 && (
                                        <ButtonList
                                          style={{
                                            float: "right"
                                          }}
                                        >
                                          <Button
                                            primary
                                            onClick={() =>
                                              handleMergeIdentitySpec(
                                                aggregateId
                                              )
                                            }
                                          >
                                            Merge Identityspec
                                          </Button>
                                        </ButtonList>
                                      )}
                                  </div>
                                }
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel style={{ padding: "0px" }}>
                              {renderTable(idnumber[1])}
                            </AccordionItemPanel>
                          </AccordionItem>
                        </Accordion>
                      ) : (
                        renderTable(idnumber[1])
                      )}
                    </>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {hasDownloadCsv && (
          <div className={styles.downloadCsv}>
            <Button
              className={styles.button}
              primary
              disabled={data.length === 0}
              onClick={() => generateCsvLink()}
            >
              Download CSV
            </Button>
          </div>
        )}{" "}
      </div>

      {showColumnSelector ? (
        <ColumnSelectorCheckbox columns={allColumns} isHidden={tableExpanded} />
      ) : null}
      {expandRecordDetailsUtil()}
      {unquarantineRecordUtil()}
    </div>
  );
};

export {
  DataTable as default,
  DropDownListFilter,
  SelectInputFilter,
  TextBoxFilter
};
